// Reward badges for the Customer Support Training Arena.
// Each topic awards three tiers: Bronze (80%+), Silver (90%+), Gold (100%).
import { GENERAL_TOPICS } from "@/data/generalTopics";

// Ascending by threshold so getEarnedTier returns the highest unlocked tier.
export const BADGE_TIERS = [
  { key: "bronze", label: "Bronze", threshold: 80 },
  { key: "silver", label: "Silver", threshold: 90 },
  { key: "gold", label: "Gold", threshold: 100 }
];

// Topics that can earn badges: the report track + every general topic.
export const BADGE_TOPICS = [
  { key: "report", label: "Report training", icon: "FileText" },
  { key: "monthly", label: "Monthly test", icon: "CalendarClock" },
  { key: "kb", label: "Knowledge Base", icon: "BookOpen" },
  ...GENERAL_TOPICS.map((t) => ({ key: t.key, label: t.label, icon: t.icon }))
];

// Highest tier earned for a given score, or null if below 80%.
export function getEarnedTier(score) {
  let earned = null;
  for (const tier of BADGE_TIERS) {
    if (score >= tier.threshold) earned = tier;
  }
  return earned;
}

// Map of topicKey -> best score, from a user's TrainingScore records.
// Falls back to track==="report" for legacy records without a topic.
// "mixed" sessions don't count toward any topic badge.
export function computeMaxByTopic(scores) {
  const maxByTopic = {};
  for (const s of scores || []) {
    const t = s.topic || (s.track === "report" ? "report" : null);
    if (!t || t === "mixed") continue;
    if (s.score > (maxByTopic[t] ?? -1)) maxByTopic[t] = s.score;
  }
  return maxByTopic;
}